import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
import { StyledH3, mediaQuery, StyledP } from 'components';

export const ReviewTileHeader = styled(StyledH3)`
  margin: 0;
`;

export const ReviewTileWrapper = styled.div`
  min-height: 11.5rem;
  width: 100%;
  border: 1px solid black;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 2rem;

  > button {
    width: fit-content;
    align-self: flex-end;
    cursor: pointer;
    color: #629eba;
    font-family: 'Lato', 'helvetica neue', 'helvetica', 'arial', sans-serif;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
    border: none;
    background-color: transparent;
    padding: 0;

    &:hover {
      color: #7c7c7c;
      text-decoration: underline;
    }
  }

  ${mediaQuery.medium`
    min-height: 15rem;
    min-width: 15rem;
    border: none;
    margin-bottom: 0;
    padding: 1rem 0;

    &:first-child {
      border-right: 1px solid black;
      margin-right: 2rem;
    }

    > button {
      align-self: flex-start;
    }
  `}
`;

export const ReviewWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;

  ${mediaQuery.small`
    flex-direction: row;
    justify-content: space-around;
  `}

  ${mediaQuery.medium`
    justify-content: flex-start;
    align-items: stretch;
    gap: 0;
  `}
`;

const ReviewSkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  max-width: 200px;

  svg {
    max-height: 8px;
    margin-bottom: 10px;
  }

  svg:last-of-type {
    margin-top: 35px;
  }
`;

export const ReviewSkeleton = (): React.JSX.Element => (
  <ReviewSkeletonWrapper data-testid="review-skeleton">
    <ContentLoader speed={0.75} height="8px" width="110px" />
    <ContentLoader speed={0.75} height="8px" width="200px" />
    <ContentLoader speed={0.75} height="8px" width="130px" />
    <ContentLoader speed={0.75} height="8px" width="80px" />
    <ContentLoader speed={0.75} height="8px" width="50px" primaryColor="#e1e8eb" />
  </ReviewSkeletonWrapper>
);

export const PaymentMethodTextWrapper = styled.div`
  margin-bottom: 1rem;
`;

export const PaymentMethodText = styled(StyledP)`
  margin: 0;
`;

export const GiftCardCodeText = styled(StyledP)`
  margin: 0;
  color: #6d6d6d;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 2.5px;
`;

export const AddPaymentButton = styled.div`
  width: 10rem;
  display: flex;
  justify-content: space-around;
  border: 1px solid black;
  box-shadow: none;
  padding: 0.5rem 0.75rem;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
`;
